// Plan CRUD — sadece super_admin
import React, { useEffect, useState } from 'react';
import api from '../services/api';
import { Button, EmptyState, Modal, FormField } from '../components/ui';

const fmt = (n) => new Intl.NumberFormat('tr-TR', { minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(n || 0);

export default function VendorPlansPage() {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editing, setEditing] = useState(null);
  const [saving, setSaving] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const r = await api.get('/vendor/plans');
      if (r.data.success) setList(r.data.data || []);
    } finally { setLoading(false); }
  };
  useEffect(() => { load(); }, []);

  const openNew = () => setEditing({
    code: '', name: '', description: '',
    monthly_price: 0, yearly_price: 0, trial_days: 0,
    user_limit: null, stock_limit: null, account_limit: null,
    monthly_invoice_limit: null, storage_mb_limit: null,
    is_trial: false, is_active: true, sort_order: 0,
  });
  const openEdit = (p) => setEditing({ ...p });

  const save = async () => {
    setSaving(true);
    try {
      if (editing.id) await api.put('/vendor/plans/' + editing.id, editing);
      else            await api.post('/vendor/plans', editing);
      setEditing(null); await load();
    } catch (e) { alert(e.response?.data?.message || 'Hata'); }
    finally { setSaving(false); }
  };

  return (
    <div className="stocks-page">
      <div className="stocks-topbar">
        <div className="stocks-topbar-left">
          <h2>Abonelik Planları</h2>
          <span className="stocks-count-badge">{list.length} plan</span>
        </div>
        <div className="stocks-topbar-right">
          <Button size="sm" onClick={openNew}>+ Yeni Plan</Button>
        </div>
      </div>

      <div className="stocks-table-wrap">
        {loading && <div style={{ padding: 16 }}>Yükleniyor...</div>}
        {!loading && list.length === 0 && <EmptyState title="Plan yok" compact />}
        {!loading && list.length > 0 && (
          <table className="stocks-table">
            <thead>
              <tr>
                <th>Kod</th><th>Ad</th>
                <th style={{ textAlign: 'right' }}>Aylık</th>
                <th style={{ textAlign: 'right' }}>Yıllık</th>
                <th style={{ textAlign: 'right' }}>Kullanıcı</th>
                <th style={{ textAlign: 'right' }}>Stok</th>
                <th style={{ textAlign: 'right' }}>Cari</th>
                <th style={{ textAlign: 'right' }}>Storage MB</th>
                <th>Trial?</th>
                <th>Aktif</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {list.map(p => (
                <tr key={p.id} className="stocks-table-row" onClick={() => openEdit(p)} style={{ cursor: 'pointer' }}>
                  <td><span className="stock-code">{p.code}</span></td>
                  <td><strong>{p.name}</strong></td>
                  <td style={{ textAlign: 'right' }}>{p.monthly_price ? `₺${fmt(p.monthly_price)}` : '-'}</td>
                  <td style={{ textAlign: 'right' }}>{p.yearly_price ? `₺${fmt(p.yearly_price)}` : '-'}</td>
                  <td style={{ textAlign: 'right' }}>{p.user_limit ?? '∞'}</td>
                  <td style={{ textAlign: 'right' }}>{p.stock_limit ? fmt(p.stock_limit) : '∞'}</td>
                  <td style={{ textAlign: 'right' }}>{p.account_limit ? fmt(p.account_limit) : '∞'}</td>
                  <td style={{ textAlign: 'right' }}>{p.storage_mb_limit ?? '∞'}</td>
                  <td>{p.is_trial ? `${p.trial_days}g Trial` : '-'}</td>
                  <td>{p.is_active ? '✓' : '✗'}</td>
                  <td><Button variant="ghost" size="sm" onClick={(e) => { e.stopPropagation(); openEdit(p); }}>Düzenle</Button></td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>

      {editing && (
        <Modal title={editing.id ? `Plan: ${editing.name}` : 'Yeni Plan'} size="lg" onClose={() => setEditing(null)}
               primaryAction={{ label: 'Kaydet', onClick: save, loading: saving }}
               cancelAction={{ label: 'Vazgeç', onClick: () => setEditing(null) }}>
          <div className="form-grid">
            <FormField label="Kod" required><input value={editing.code} onChange={e => setEditing({ ...editing, code: e.target.value })} disabled={!!editing.id} /></FormField>
            <FormField label="Ad" required><input value={editing.name} onChange={e => setEditing({ ...editing, name: e.target.value })} /></FormField>
            <FormField label="Aylık Fiyat (₺)"><input type="number" value={editing.monthly_price || 0} onChange={e => setEditing({ ...editing, monthly_price: parseFloat(e.target.value) || 0 })} /></FormField>
            <FormField label="Yıllık Fiyat (₺)"><input type="number" value={editing.yearly_price || 0} onChange={e => setEditing({ ...editing, yearly_price: parseFloat(e.target.value) || 0 })} /></FormField>
            <FormField label="Trial Mi?">
              <select value={editing.is_trial ? '1' : '0'} onChange={e => setEditing({ ...editing, is_trial: e.target.value === '1' })}>
                <option value="0">Hayır</option><option value="1">Evet</option>
              </select>
            </FormField>
            <FormField label="Trial Süresi (gün)"><input type="number" value={editing.trial_days || 0} onChange={e => setEditing({ ...editing, trial_days: parseInt(e.target.value) || 0 })} /></FormField>
            <FormField label="Kullanıcı Sınırı (boş=∞)"><input type="number" value={editing.user_limit ?? ''} onChange={e => setEditing({ ...editing, user_limit: e.target.value === '' ? null : parseInt(e.target.value) })} /></FormField>
            <FormField label="Stok Sınırı"><input type="number" value={editing.stock_limit ?? ''} onChange={e => setEditing({ ...editing, stock_limit: e.target.value === '' ? null : parseInt(e.target.value) })} /></FormField>
            <FormField label="Cari Sınırı"><input type="number" value={editing.account_limit ?? ''} onChange={e => setEditing({ ...editing, account_limit: e.target.value === '' ? null : parseInt(e.target.value) })} /></FormField>
            <FormField label="Aylık Fatura Sınırı"><input type="number" value={editing.monthly_invoice_limit ?? ''} onChange={e => setEditing({ ...editing, monthly_invoice_limit: e.target.value === '' ? null : parseInt(e.target.value) })} /></FormField>
            <FormField label="Storage Sınırı (MB)"><input type="number" value={editing.storage_mb_limit ?? ''} onChange={e => setEditing({ ...editing, storage_mb_limit: e.target.value === '' ? null : parseInt(e.target.value) })} /></FormField>
            <FormField label="Sıralama"><input type="number" value={editing.sort_order || 0} onChange={e => setEditing({ ...editing, sort_order: parseInt(e.target.value) || 0 })} /></FormField>
            <FormField label="Aktif">
              <select value={editing.is_active !== false ? '1' : '0'} onChange={e => setEditing({ ...editing, is_active: e.target.value === '1' })}>
                <option value="1">Evet</option><option value="0">Hayır</option>
              </select>
            </FormField>
          </div>
        </Modal>
      )}
    </div>
  );
}
